<script setup lang="ts">
import BackstageIcon from '@/components/common/BackstageIcon.vue';
import { useExceptionReportStore } from '@/stores/exception-report';
import { storeToRefs } from 'pinia';

const exceptionReportStore = useExceptionReportStore();
const { isBusy: isReportBusy } = storeToRefs(exceptionReportStore);
</script>
<template>
  <div class="admin-layout">
    <div class="admin-header">
      <div class="header-main-bar">
        <router-link to="/" class="header-logo"> </router-link>
        <h3 class="page-title" data-cy="page-title">
          {{ $t('admin.welcome') }}
        </h3>
      </div>
      <nav class="admin-nav">
        <router-link to="/admin/retry-orders">
          {{ $t('admin.retry') }}
        </router-link>
        <router-link to="/admin/resubmit-cases">
          {{ $t('admin.resubmit_cases') }}
        </router-link>
        <router-link to="/admin/delete-orders">
          {{ $t('admin.delete') }}
        </router-link>
        <router-link to="/admin/health">
          {{ $t('admin.health.title') }}
        </router-link>
        <router-link to="/admin/product-style-exceptions">
          {{ $t('admin.productStyleException.title') }}
        </router-link>
        <router-link to="/admin/exception-reports">
          {{ $t('admin.exceptionReports.title') }}
          <BackstageIcon v-if="isReportBusy" class="nav-loading-icon" name="loading" />
        </router-link>
        <router-link to="/admin/cache">
          {{ $t('admin.cache.title') }}
        </router-link>
      </nav>
    </div>
    <div class="scroll-wrapper">
      <div class="main-content">
        <router-view />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.admin-layout {
  padding-top: 20px;
  min-height: 100vh;
  flex-flow: column;
  flex-direction: column;
  display: flex;

  .admin-header {
    width: 100%;

    .header-main-bar {
      display: flex;
      align-items: center;

      .header-logo {
        display: block;
        position: relative;

        @include breakpoint(xlarge) {
          left: inherit;
        }
      }
      h3 {
        display: block;
        padding: 0 0 0 40px;
      }
    }

    .admin-nav {
      @include main-max-with;

      width: 100%;
      text-align: left;
      margin: 0 auto;
      padding: 10px 0 0 30px;
      display: flex;
      gap: 20px;

      a {
        background: none;
        padding: 10px;
        color: var(--primary-text-color);
        border: none;
        cursor: pointer;

        .nav-loading-icon {
          display: inline-block;
          margin-left: 6px;
          vertical-align: middle;
          width: 24px;
          height: 24px;
        }

        &.router-link-active,
        &:hover {
          border-bottom: 1px solid;
        }
      }
    }
  }
}
</style>
